import { SyntheticEvent, useCallback } from "react";
import { useAuthFlow } from "@/domains/auth/containers/context";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthResetTfaAccountRecovery from "@/domains/auth/components/reset-tfa/AuthResetTfaAccountRecovery";

export default function AuthResetTfaSMSContainer() {
  const { goBack } = useAuthFlow();
  const onSubmit = useCallback(async (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    // TODO: отправить пользователя к администратору
  }, []);

  return (
    <>
      <AuthTitle back={goBack}>Нет доступа к SMS</AuthTitle>
      <AuthResetTfaAccountRecovery onSubmit={onSubmit} />
    </>
  );
}
